var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
export var Indicator = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("svg", __assign({}, rest, { viewBox: "0 0 8 8", className: cn(styles.indicator, className) }),
        React.createElement("circle", { fill: "currentColor", cx: "4", cy: "4", r: "4" })));
};



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/indicator/index.tsx
// module id = oZdA
// module chunks = 2